import endpoints from 'constants/endpoints';
import { CREATE_NOTE, DELETE_NOTE, UPDATE_NOTE } from 'constants/types';
import { safePostCall } from 'helpers/firebaseSetup';

// these run while the notes card stays on screen, so they never touch the global
// site loader: raising it unmounts the whole router and looks like a page reload.
// each thunk resolves to { ok } so the form can show its own pending/error state.

function notesRequest(payload) {
  return safePostCall(endpoints.awsProxy.safePost, {
    ...payload,
    endpoint: endpoints.zoho.updatePortalNote,
    isZohoRequest: true
  });
}

/**
 * saves an edited note
 * @param closeModal - closes the note modal once the change is stored
 * @param note - note being edited, already carrying its id and date
 */
export const updatePortalNote = (closeModal, note) => async dispatch => {
  // safePostCall resolves with null when the request fails
  const response = await notesRequest({
    ...note,
    create: false,
    delete: false
  });
  if (!response) return { ok: false };

  dispatch({ type: UPDATE_NOTE, payload: note });
  closeModal();
  return { ok: true };
};

/**
 * creates a note for the logged agent
 * @param closeModal - closes the note modal once the note exists
 * @param noteData - title and description typed in the form
 */
export const createPortalNote =
  (closeModal, noteData) => async (dispatch, getState) => {
    const userId = getState().user.zohoData.id;
    const response = await notesRequest({
      ...noteData,
      create: true,
      delete: false,
      userId
    });
    if (!response) return { ok: false };

    let created;
    try {
      created = JSON.parse(response.data.details.output);
    } catch (error) {
      console.error('createPortalNote: unreadable response', error);
      return { ok: false };
    }

    dispatch({ type: CREATE_NOTE, payload: { ...noteData, id: created.id } });
    closeModal();
    return { ok: true };
  };

/**
 * removes a note
 * @param closeModal - closes the note modal once the note is gone
 * @param id - zoho id of the note to delete
 */
export const deletePortalNote = (closeModal, id) => async dispatch => {
  const response = await notesRequest({ id, create: false, delete: true });
  if (!response) return { ok: false };

  dispatch({ type: DELETE_NOTE, payload: id });
  closeModal();
  return { ok: true };
};
